import { useState } from "react";
import { Box, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const WHATSAPP_NUMBER = "5491177213649";
const WHATSAPP_MESSAGE = "Hola! Me gustaría agendar una visita técnica";

function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        position: "fixed",
        bottom: { xs: 20, md: 30 },
        right: { xs: 20, md: 30 },
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      {/* Texto expandible */}
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "30px",
          px: 2.5,
          py: 1.5,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          opacity: isHovered ? 1 : 0,
          transform: isHovered ? "translateX(0)" : "translateX(20px)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          pointerEvents: "none",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.9rem",
            fontWeight: 600,
            color: "#25D366",
            whiteSpace: "nowrap",
          }}
        >
          ¡Chatea con nosotros!
        </Typography>
      </Box>

      {/* Botón principal */}
      <Box
        sx={{
          width: { xs: 60, md: 65 },
          height: { xs: 60, md: 65 },
          borderRadius: "50%",
          background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: isHovered
            ? "0 10px 35px rgba(37, 211, 102, 0.5)"
            : "0 6px 25px rgba(37, 211, 102, 0.35)",
          transform: isHovered ? "scale(1.08)" : "scale(1)",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: -4,
            borderRadius: "50%",
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            opacity: 0.3,
            animation: "ripple 2s ease-out infinite",
          },
          "@keyframes ripple": {
            "0%": {
              transform: "scale(1)",
              opacity: 0.3,
            },
            "100%": {
              transform: "scale(1.4)",
              opacity: 0,
            },
          },
          "&:active": {
            transform: "scale(0.95)",
          },
        }}
      >
        <WhatsAppIcon
          sx={{
            fontSize: { xs: 30, md: 34 },
            color: "white",
            filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
          }}
        />
      </Box>
    </Box>
  );
}

export default WhatsAppButton;
